// Detects if soft delete is enabled on the given model class by checking if a "deleted_at"-column exists.
// "deleted_at" has to be defined as an attribute on the resource for this to work.
export default function softDeleteModelDetect(modelClass) {
  return "deleted_at" in modelClass.modelClassData().attributes
}
